import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue";
import TableBase from "./TableBase.vue";
import { $get } from "@/plugins/api/api";
import { Paths } from "@/plugins/api/paths";
import { CheckApprovalAttendance } from "@/models/approval/ApprovalResponse";
import AttendanceExpandItem from "../expand/AttendanceExpandItem.vue";

type Props = {
  shiftId: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'AttendanceDialogTable',
  props: {
    shiftId: null
  },
  setup(__props: any) {

const props = __props as {
  shiftId: string;
};



const items = ref<CheckApprovalAttendance[]>([]);

const getItems = async () => {
  const response = await $get<CheckApprovalAttendance[]>(
    `${Paths.approval.shiftTable.attendance}/${props.shiftId}`
  );
  if (response) items.value = response;
};

watch(
  () => props.shiftId,
  async () => {
    await getItems();
  },
  { immediate: true }
);

return { __sfc: true,props, items, getItems, TableBase, AttendanceExpandItem }
}

})